// @flow

// Utils
import createReducer from 'fc-utils/createReducer'

// Initial State
import opState from './initialState'

import {
  initialState as billingInfoState,
  reducers as composeBillingInfoReducer,
} from 'hfty-operator-billing-info'

// Accounts Operator
import composeAccountReducers from 'hfty-operator-accounts/src/reducers'

const accountReducers = composeAccountReducers()
const billingInfoReducers = composeBillingInfoReducer()

// Exports
export default createReducer({
  ...opState,
  ...billingInfoState,
}, {
  ...accountReducers,
  ...billingInfoReducers,
})
